import { useTranslation } from "react-i18next";
import step1Img from "../../../../assets/instruction/enter-visa-info-guide/step1.jpg";
import step2Img from "../../../../assets/instruction/enter-visa-info-guide/step2.jpg";
import step3Img from "../../../../assets/instruction/enter-visa-info-guide/step3.jpg";
import step4Img from "../../../../assets/instruction/enter-visa-info-guide/step4.jpg";

const EnterVisaInfoGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 py-6">
      <p>
        <span className="text-primary-blue font-bold">
          {t("instructions.step", { number: "1" })}:{" "}
        </span>
        {t("instructions.instructions_list.enter_info_guide.content.step1")}
      </p>
      <img src={step1Img} alt="Step 1" className="w-full" />

      <p>
        <span className="text-primary-blue font-bold">
          {t("instructions.step", { number: "2.1" })}:{" "}
        </span>
        {t("instructions.instructions_list.enter_info_guide.content.step2.1")}
      </p>
      <img src={step2Img} alt="Step 2" className="w-full" />

      <p>
        <span className="text-primary-blue font-bold">
          {t("instructions.step", { number: "2.2" })}:{" "}
        </span>
        {t("instructions.instructions_list.enter_info_guide.content.step2.2")}
      </p>
      <img src={step3Img} alt="Step 3" className="w-full" />

      <p>
        <span className="text-primary-blue font-bold">
          {t("instructions.step", { number: "3" })}:{" "}
        </span>
        {t("instructions.instructions_list.enter_info_guide.content.step3")}
      </p>
      <img src={step4Img} alt="Step 4" className="w-full" />
    </div>
  );
};

export default EnterVisaInfoGuide;
